module.exports = __webpack_public_path__ + "img/16.f78e44f9.jpg";